<div class="table-of-contents-component text-center bg-alt-color">
    <a [routerLink]
       *ngFor="let link of links; first as isFirst; last as isLast"
       fragment="{{link.id}}"
       class="d-block link-text-color pt-1 pb-1 pl-3 pr-3 bolder"
       [class.pt-3]="isFirst"
       [class.pb-3]="isLast"
       [ngClass]="link.active? 'bg-alt-color-hover' : ''">{{link.name}}</a>
</div>
